module.exports = __webpack_public_path__ + "img/logo-mobile-dark.cf5be6e3.svg";